import React from 'react';
import ReactDOM from 'react-dom';
import {App} from './App';
import 'tachyons/css/tachyons.css';

ReactDOM.render(
  <App />,
  document.getElementById('root')
);
